import React from "react";
import { Link } from "react-router-dom";

/**
 * Joy Pearl wordmark with the actual brand logo (transparent PNG).
 * Variant prop: "default" (color logo) | "white" (for dark backgrounds).
 */
export const Logo = ({ className = "", variant = "default", showWordmark = true }) => {
  const src = variant === "white" ? "/logo-white.png" : "/logo.png";
  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`} data-testid="brand-logo">
      <img
        src={src}
        alt="Joy Pearl"
        className="h-9 w-auto transition-transform duration-300 group-hover:scale-105"
        data-testid="brand-logo-image"
      />
      {showWordmark && (
        <span
          className={`font-serif text-xl md:text-2xl tracking-tight transition-colors hidden sm:inline ${
            variant === "white"
              ? "text-white group-hover:text-brand-blush"
              : "text-brand-ink group-hover:text-brand-primary"
          }`}
        >
          Joy <span className="italic font-normal">Pearl</span>
        </span>
      )}
    </Link>
  );
};
